/**
 * The two mineral fields under the world, shared verbatim by the generator
 * (which writes per-parcel values) and the client's resources overlay (which
 * paints the continuous field). Both must sample identical noise — a mine
 * gate that disagrees with the heatmap the player scouted is a broken
 * promise — so the parameters live here and nowhere else.
 */

import { fbm2D } from "./noise.js";

export interface ResourceField {
  readonly key: "ore" | "stone";
  readonly seed: number;
  /** Noise frequency in cycles per degree, and the lon/lat offsets. */
  readonly scale: number;
  readonly offX: number;
  readonly offY: number;
  readonly octaves: number;
}

/**
 * `ore` keeps the exact parameters of the original single resource field so
 * the ground players scouted before the split does not move. `stone` is a new
 * independent field for quarryable ground ("concrete" on the overlay).
 */
export const RESOURCE_FIELDS: readonly ResourceField[] = [
  { key: "ore", seed: 3037, scale: 31, offX: -61, offY: 41, octaves: 3 },
  { key: "stone", seed: 7411, scale: 23, offX: 17, offY: -29, octaves: 3 },
];

export function sampleResourceField(field: ResourceField, lon: number, lat: number): number {
  return fbm2D(lon * field.scale + field.offX, lat * field.scale + field.offY, field.seed, field.octaves);
}
